import api from '@/utils/api';

const PROTECTED_BASE_URL = '/api/app-installation';
const PUBLIC_HANDOFF_BASE_URL = '/auth/install-handoff';
const REQUEST_TIMEOUT_MS = 5000;
const ONE_TIME_EXCHANGE_TIMEOUT_MS = 20000;

function post(url, payload, timeout = REQUEST_TIMEOUT_MS) {
    return api.post(url, payload, {
        ignoreModal: true,
        timeout,
        withCredentials: true
    }).then(response => response.data);
}

export function getInstallCampaignStatus(payload) {
    return post(`${PROTECTED_BASE_URL}/status`, payload);
}

export function snoozeInstallCampaign(payload) {
    return post(`${PROTECTED_BASE_URL}/snooze`, payload);
}

export function recordInstallEvidence(payload) {
    return post(`${PROTECTED_BASE_URL}/evidence`, payload);
}

export function sendInstallHeartbeat(payload) {
    return post(`${PROTECTED_BASE_URL}/heartbeat`, payload);
}

export function createInstallHandoff(payload) {
    return post(`${PROTECTED_BASE_URL}/handoffs`, payload);
}

export function inspectInstallHandoff(code) {
    return post(`${PUBLIC_HANDOFF_BASE_URL}/inspect`, {code});
}

export function exchangeInstallHandoff(payload) {
    return post(
        `${PUBLIC_HANDOFF_BASE_URL}/exchange`,
        payload,
        ONE_TIME_EXCHANGE_TIMEOUT_MS
    );
}

export function exchangeInstallBootstrapSession(payload) {
    return post(
        `${PUBLIC_HANDOFF_BASE_URL}/bootstrap`,
        payload,
        ONE_TIME_EXCHANGE_TIMEOUT_MS
    );
}
